import { DynamicDecorator } from '@natu/ui/Decorators/DynamicDecorator';

export const BothSidesDecorator = () => (
  <>
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-butterscotch absolute bottom-[-64px] right-[15%] h-32 w-32 md:hidden"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-airborne absolute bottom-6 left-[25%] h-6 w-6 md:bottom-28 md:left-auto md:right-[12%] md:rotate-180"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-butterscotch absolute right-4 top-[-5px] hidden h-32 w-32 rotate-[-90deg] overflow-hidden rounded-br-[40px] md:block lg:right-[23px] lg:h-36 lg:w-36"
    />
    <DynamicDecorator
      decorator="halfStadium"
      className="absolute right-14 top-[-18px] h-12 w-12 text-gray-100 md:right-[20%] md:h-16 md:w-16 lg:top-8"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="absolute left-[12%] top-20 hidden h-8 w-8 rotate-[-90deg] text-white md:block"
    />
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-butterscotch absolute left-[38px] top-52 hidden h-6 w-6 md:block"
    />
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-airborne absolute bottom-16 left-[20%] hidden md:block"
    />
  </>
);
